<template>
  <!-- TODO: エスケープキーをブロック -->
  <v-dialog
    v-model="modal"
    fullscreen
    @keydown.esc="modal = false"
    persistent
  >
  <v-toolbar
    flat
    dark
    color="primary"
  >
  <v-toolbar-title class="h2">通知の設定はいかがですか？</v-toolbar-title>
  <v-spacer></v-spacer>
  <v-btn
    icon
    dark
    @click="close"
  >
    <v-icon>mdi-close</v-icon>
  </v-btn>
  </v-toolbar>
    <v-card>

      <!-- 通知設定本体 -->
      <notifySetting />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">
          設定を終える
        </v-btn>
        <!-- <v-btn color="blue darken-1" text @click="submit">
          送信
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import notifySetting from './notifySetting.vue';
import firebase from "firebase/app"
import "firebase/firestore"
export default {
  data() {
    return {
      modal: true,
    };
  },
  components: {
    notifySetting,
  },
  created() {
    firebase.firestore().collection('userConfig').doc(this.uid).set(
      {
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        isActive: true,
      },
      { merge: true }
    )
  },
  methods: {
    submit () {
      this.$store.dispatch('auth/setAskForNotificationModalClosed');
      this.$store.dispatch('notification/create', {
        title: this.title,
        text: this.text,
        url: this.url,
      });
    },
    close () {
      this.$store.dispatch('auth/setAskForNotificationModalClosed');
    },
  },
  computed: {
    uid() {
      return this.$store.state.auth.user.uid || '';
    },
  }
}
</script>